import { useParams } from 'react-router';
/**
 * @returns the projectId from the current route (url) or null if it is not present.
 */
export const useProjectIdOrNull = () => {
    const { projectId } = useParams();
    try {
        return Number.parseInt(projectId ?? '0', 10);
    }
    catch (e) {
        console.log('Error parsing project ID:', e);
        return null;
    }
};
